module.exports = __webpack_public_path__ + "static/media/193.1213fb87.jpg";